module.exports = __webpack_public_path__ + "media/10.2f8247cf.mp3";